

const defineWinnerX = () => {

    return {
        type: "DEFINE_WINNER_X",
        data: [
            { // 1
                "0": [true, "no"],
                "1": [true, "no"],
                "2": [true, "no"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 2
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [true, "no"],
                "4": [true, "no"],
                "5": [true, "no"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 3
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [true, "no"],
                "7": [true, "no"],
                "8": [true, "no"]
            },
            { // 4
                "0": [true, "no"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [true, "no"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [true, "no"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 5
                "0": [false, "default"],
                "1": [true, "no"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [true, "no"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [true, "no"],
                "8": [false, "default"]
            },
            { // 6
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [true, "no"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [true, "no"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [true, "no"]
            },
            { // 7
                "0": [true, "no"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [true, "no"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [true, "no"]
            },
            { // 8
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [true, "no"],
                "3": [false, "default"],
                "4": [true, "no"],
                "5": [false, "default"],
                "6": [true, "no"],
                "7": [false, "default"],
                "8": [false, "default"]
            }
        ]

        // {"0": [false, "default"],
        // "1": [false, "default"],
        // "2": [false, "default"],
        // "3": [false, "default"],
        // "4": [false, "default"],
        // "5": [false, "default"],
        // "6": [false, "default"],
        // "7": [false, "default"],
        // "8": [false, "default"]}

    } //end of return
}//end of function


export default defineWinnerX


